import { Link } from 'react-router-dom';
const AccessDenied = () => {
  return (
    <>
      <div className="container">
        <div className="error-text">
          <h1 className="danger">You don't have sufficient access!! </h1>
          <br />
          <p className="danger-para">Please contact administrator for further support.</p>
          <div className="home-button">
            <Link className="btn btn-outline-primary" to="/">
              Home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default AccessDenied;
